import type { SystemPreferenceEntity } from "domain/entity/SystemPreference/SystemPreferenceEntity";
import { useSystemPreferenceVM } from "presentation/hook/SystemPreference/useSystemPreferenceVM";
import { useANAInfoTracked } from "presentation/store/ANAInfo";
import { useSystemPreferenceTracked } from "presentation/store/SystemPreference/SystemPreferenceProvider";
import { useMemo, useState } from "react";
import { DialogModal, HPHButton, IconButton } from "veronica-ui-component/dist/component/core";
import { IPreferenceModal } from "./SaveNewPreferenceModal";
import { CriteriaItemContainer } from "../../CriteriaItemContainer";
import { FieldType, NbisCommonField } from "../../NbisCommonField";

export const DeletePreferenceModal: React.FC<IPreferenceModal> = (props: IPreferenceModal) => {
    const { visible } = props;
    const [systemPreferenceState] = useSystemPreferenceTracked();
    const systemPreferenceVM = useSystemPreferenceVM();
    const [anaInfoState] = useANAInfoTracked();
    const [preferenceKey, setPreferenceKey] = useState<string>('');

    const onConfirmClicked = () => {
        const selectedPreference = systemPreferenceState.allSystemPreferences?.filter((preference: SystemPreferenceEntity) =>
            preference.name === preferenceKey)[0]!;
        Promise.allSettled([
            systemPreferenceVM.onDeleteSystemPreference(selectedPreference),
        ]).then(() => {
            systemPreferenceVM.getTableSystemPreferences(props.entryPoint, props.tableId, anaInfoState.userName);
            props?.gridRef?.current?.api?.resetColumnState();
        });

        if (props.showDeleteModal) {
            props.showDeleteModal();
        }
        setPreferenceKey('');
    }

    const onClose = async () => {
        setPreferenceKey('');
        props.showDeleteModal && props.showDeleteModal()
    }

    const memoName = useMemo(() =>
        <div className='im-flex-row-item' style={{ minWidth: "300px", maxWidth: "300px", width: "30%", marginBottom: "24px" }}>
            <NbisCommonField
                //errorMessages={allFormState}
                isReadOnly={false}
                isShowOptional={false}
                isMultipleDropDown={false}
                readOnlyValue={preferenceKey ?? ""}
                fieldValue={preferenceKey ?? ""}
                fieldLabel={"Name"}
                //isSaveClicked={isSaveClicked}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'Name'}
                isShowMissingError={true}
                maxLength={10}
                options={systemPreferenceState?.allSystemPreferences?.filter((preference) => preference.userId === anaInfoState.userName)?.map(preference => ({
                    dropdownLabel: preference.name,
                    tagLabel: preference.name,
                    value: preference.name,
                }))}
                requiredFieldList={[]}
                onFieldChange={(_: any, value: string) => setPreferenceKey(value as string)} />
        </div>
        , [anaInfoState.userName, preferenceKey, systemPreferenceState?.allSystemPreferences])

    return <DialogModal
        appendTo='self'
        showButton={false}
        visible={visible}
        positions="center"
        resizable={false}
        header={
            <div className="im-charge-data-search-confirm-modal-header">
                <span className="name">DELETE PREFERENCE</span>
                <IconButton fileName='Icon-cross' size="medium" onClick={onClose} tooltipDisable={true} />
            </div>
        }
        dialogContent={
            <div className={'add-edit-form'} style={{ maxHeight: '16vh', height: '16vh', overflow: 'auto' }}>
                <div className="flex-row-auto">
                    <div className={'flex-row-item'}>
                        <CriteriaItemContainer>
                            {memoName}
                        </CriteriaItemContainer>

                    </div>
                </div>
            </div>
        }
        className="im-charge-data-search-confirm-modal"
        footer={
            <div className="im-charge-data-search-confirm-modal-footer">
                <HPHButton label={'Confirm'} size={'Small'} theme={'Primary'} onClick={onConfirmClicked} />
            </div>
        }
    />;
};
